import { Box, Grid, Theme, makeStyles, Typography } from '@material-ui/core';
import { Button, DialogState, EditableDialog, FilterButton, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ManageTemplatesGrid } from './manageTemplatesGrid';
import { useStore } from 'libs/client-portal-shared/src/app/hooks/index';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between !important',
    width: '100%',
  },
  button: {
    margin: '10px',
    minWidth: '150px',
    display: 'flex-end'
  },
}));

export const ManageTemplatesDashboard = observer(() => {

  const { salesforceLenderStore, ringCentralStore } = useStore();

  const classes = useStyles();


  useEffect(() => {
    ringCentralStore.clearSelectedTemplates();
    ringCentralStore.templatesGrid.resetAndFetchGridData();
  }, [salesforceLenderStore]);

  const onCreateTemplate = () => {
    ringCentralStore.setOpenCreateTemplateModal(true);
    ringCentralStore.setFromJourneyBuilder(false);
    ringCentralStore.setActiveAfter(null);
    ringCentralStore.setIsTemplateActive(true);
  }

  const selectedCount = ringCentralStore.selectedTemplateIds.length;

  return (
    <>
      <ManageTemplatesGrid
        toolbar={
          <Toolbar>
            <Grid container direction="row" className={classes.header}>
              <Grid item>
                <Button className={classes.button} variant="outlined" size="small" color="primary" testId="activate_templates"
                  disabled={!selectedCount} onClick={() => ringCentralStore.updateTemplatesActiveStatus(true)}>
                  Activate{selectedCount ? ` (${selectedCount})` : ''}
                </Button>
                <Button className={classes.button} variant="outlined" size="small" color="primary" testId="deactivate_templates"
                  disabled={!selectedCount} onClick={() => ringCentralStore.updateTemplatesActiveStatus(false)}>
                  Deactivate{selectedCount ? ` (${selectedCount})` : ''}
                </Button>
              </Grid>
              <Button className={classes.button} variant="contained" onClick={onCreateTemplate} size="small" color="primary" testId="send_bulk_messages">
                Create Template
              </Button>
            </Grid>
          </Toolbar>
        }
      />
    </>
  );
});